module.exports = __webpack_public_path__ + "img/few_gas_station.4fc87c84.png";